const mainConfig = {
    guides: {
        seo: {
            title: `Guides That Make Matched Betting Easy`,
            description: "Learn how to profit from bookmaker offers with insanely easy-to-follow matched betting guides. Our matched betting resources are free, forever.",
            route: "/guides",
        }
    },
    calculators: {
        seo: {
            title: `Insanely Intuitive Matched Betting Calculators`,
            description: "Lock in profit from bookmaker offers with insanely easy-to-use matched betting calculators. Our matched betting resources are free, forever.",
            route: "/calculators",
        }
    },
    home: {
        seo: {
            title: `Learn to Profit from Matched Betting | Matched Edge`,
            description: "Lock in profit from bookmaker offers with insanely easy-to-use matched betting guides and calculators. Our matched betting resources are free, forever.",
            route: "/",
        }
    },
    faqs: {
        seo: {
            title: `Matched Betting FAQs | Matched Edge`,
            description: "Lock in profit from bookmaker offers with insanely easy-to-use matched betting guides and calculators. Our matched betting resources are free, forever.",
            route: "/faqs",
        }
    },
    affiliateDisclosure: {
        seo: {
            title: `Affiliate Disclosure | Matched Edge`,
            description: "This page explains how Matched Edge uses affiliate links and the role they play in supporting the site.",
            route: "/affiliatedisclosure",
        }
    },
    
    privacy: {
        seo: {
            title: `Privacy Policy | Matched Edge`,
            description: "Read how Matched Edge collects, uses, and protects your personal information in accordance with privacy regulations.",
            route: "/privacy",
        }
    },
    
    disclaimer: {
        seo: {
            title: `Disclaimer | Matched Edge`,
            description: "Important disclaimers and limitations of liability for the information and tools provided on Matched Edge.",
            route: "/disclaimer",
        }
    }    
}
export default mainConfig;